<div class="content-preview">
    <app-content-view
        [content]="slide.content"
        [renderMedia]="false"
        class="content-preview__content"
    ></app-content-view>
</div>
